import { z } from 'zod';
import { SALES_ORDER_REVERT_TARGETS } from '../../sales-order-status/sales-order-revert-target.js';
import { requiredUuidString } from '../zod-helpers/index.js';
import { REVERT_REASON_MAX_LENGTH } from './revert-reason-max-length.js';
const REVERT_REASON_REQUIRED = 'Enter a reason for moving this order back.';
// The reason is shown in History, so a blank one is refused too.
export const revertSalesOrderStatusInputSchema = z.object({
    salesOrderId: requiredUuidString('Sales order is required.', 'Invalid sales order selection.'),
    to: z.enum(SALES_ORDER_REVERT_TARGETS, { error: 'Choose the stage to move back to.' }),
    reason: z
        .string({ error: REVERT_REASON_REQUIRED })
        .trim()
        .min(1, REVERT_REASON_REQUIRED)
        .max(REVERT_REASON_MAX_LENGTH),
});
//# sourceMappingURL=revert-status-input.js.map